<template>
  <div>
    <ws-list-view
      class="ws-logs__list is-table is-small"
      itemFieldIdKey="id"
      :data="examLogs"
      :columns="columns"
      :header="true"
      :bordered="true"
      :striped="true"
      :detailed="false"
    >
      <template slot="skeleton">
        <ws-list-view-skeleton-item
          :height="'39px'"
          :boxCount="1"
          :boxHeights="['38px']"
        />
        <ws-list-view-skeleton-item
          :height="'42px'"
          :boxCount="3"
          :boxHeights="['25px', '25px', '25px', '25px']"
        />
        <ws-list-view-skeleton-item
          :height="'42px'"
          :boxCount="3"
          :boxHeights="['25px', '25px', '25px', '25px']"
        />
        <ws-list-view-skeleton-item
          :height="'42px'"
          :boxCount="3"
          :boxHeights="['25px', '25px', '25px', '25px']"
        />
        <ws-list-view-skeleton-item
          :height="'42px'"
          :boxCount="3"
          :boxHeights="['25px', '25px', '25px', '25px']"
        />
        <ws-list-view-skeleton-item
          :height="'42px'"
          :boxCount="3"
          :boxHeights="['25px', '25px', '25px', '25px']"
        />
      </template>
      <template slot-scope="props">
        <ws-list-view-item-column>
          <div class="is-fullwidth">
            <ws-time-formatter
              data-id="day-cm1-column"
              class="is-size-4"
              format="LLL"
              :date="props.row.action_time"
            />
          </div>
        </ws-list-view-item-column>
        <ws-list-view-item-column>
          <div class="is-fullwidth">
            {{ getLogActionCategory(props.row.category).label }}
          </div>
        </ws-list-view-item-column>
        <ws-list-view-item-column>
          <div class="is-fullwidth">
            {{ getLogField(props.row.field).label }} <br>
            <template
              v-if="props.row.expert_id && isExperts(props.row.category, props.row.expert_id) && getAuthor(props.row.expert_id)"
            >
              <span class="has-text-weight-bold">
              {{ getAuthor(props.row.expert_id).last.display }} {{ getAuthor(props.row.expert_id).first.display }}
              </span>
              <span> ({{  getAuthor(props.row.expert_id).email }})</span>
            </template>
          </div>
        </ws-list-view-item-column>
        <ws-list-view-item-column>
          <div class="is-fullwidth log-cell">
            <template
              v-if="props.row.old_value &&
                isExperts(props.row.category, props.row.old_value) &&
                getAuthor(props.row.old_value)"
            >
              <span class="has-text-weight-bold">{{ getAuthor(props.row.old_value).last.display }} {{ getAuthor(props.row.old_value).first.display }}</span>
              <span> ({{  getAuthor(props.row.old_value).email }})</span>
            </template>
            <template v-else-if="isDateFormat(props.row.field)">
                <span>{{getDate(props.row.old_value)}}</span>
            </template>
            <template v-else>
              {{ getLogValue(props.row.old_value, props.row.field).label }}
            </template>
          </div>
        </ws-list-view-item-column>
        <ws-list-view-item-column>
          <div class="is-fullwidth log-cell">
            <template
              v-if="props.row.new_value &&
                isExperts(props.row.category, props.row.new_value) &&
                getAuthor(props.row.new_value)"
            >
              <span class="has-text-weight-bold">{{ getAuthor(props.row.new_value).last.display }} {{ getAuthor(props.row.new_value).first.display }}</span>
              <span> ({{  getAuthor(props.row.new_value).email }})</span>
            </template>
            <template v-else-if="isDateFormat(props.row.field)">
                <span>{{getDate(props.row.new_value)}}</span>
            </template>
            <template v-else>
              {{ getLogValue(props.row.new_value, props.row.field).label }}
            </template>
          </div>
        </ws-list-view-item-column>
        <ws-list-view-item-column>
          <div class="is-fullwidth log-action">
            <b-tag :type="`is-${getLogAction(props.row.action).type}`">
              {{ getLogAction(props.row.action).label }}
            </b-tag>
          </div>
        </ws-list-view-item-column>
        <ws-list-view-item-column>
          <div
            class="is-fullwidth log-cell"
            v-if="getAuthor(props.row.author)"
          >
            <span class="has-text-weight-bold">{{ getAuthor(props.row.author).last.display }} {{ getAuthor(props.row.author).first.display }}</span>
            <span> ({{  getAuthor(props.row.author).email }})</span>
          </div>
        </ws-list-view-item-column>
      </template>
      <template
        slot="details"
        slot-scope="props"
      >
        <pre
          class="is-fullwidth"
          style="background-color: #262d3b; color: #c0cc93; border-radius: 5px;"
        >{{ props.row.additional_info }}</pre>
      </template>
      <template slot="empty">
        <p>{{ $t('Нет данных для отображения')}}</p>
      </template>
    </ws-list-view>
    <footer class="ws-logs__footer">
      <ws-pagination
        @change="(e) => $emit('pageChange', e)"
        :align="'right'"
        :totalItems="examPagination.total"
        :itemsPerPage="examPagination.per_page"
        :disabled="isExamPending"
        :currentIndex="examPagination.current_page - 1"
      >
      </ws-pagination>
    </footer>
  </div>
</template>

<script>
import {
  FILE_CATEGORY,
  LOG_VALUE_SETTINGS,
  getLogActionCategory,
  isValidGuid,
  isExperts,
  getLogAction,
  getLogField,
  isDateFormat
} from '@/components/de/demo-exams/data/log-data.js'
export default {
  name: 'WsExamLog',
  props: {
    examLogs: {
      type: Array,
      default: () => []
    },
    users: {
      type: Array,
      default: () => []
    },
    files: {
      type: Object,
      default: () => ({})
    },
    examPagination: {
      type: Object,
      default: () => ({})
    },
    isExamPending: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      columns: [
        {
          field: 'created_at',
          label: 'Время'
          // width: '100px'
        },
        {
          field: 'category',
          label: 'Категория'
        },
        {
          field: 'field',
          label: 'Поле'
        },
        {
          field: 'old_value',
          label: 'Старое значение'
        },
        {
          field: 'new_value',
          label: 'Новое значение'
        },
        {
          field: 'action',
          label: 'Действие'
        },
        {
          field: 'user_id',
          label: 'Автор'
        }
      ]
    }
  },
  methods: {
    getLogActionCategory,
    getLogField,
    isExperts,
    isValidGuid,
    getLogAction,
    isDateFormat,
    getAuthor (guid) {
      return this.users.find(i => i.guid === guid)
    },
    getLogValue (value, field) {
      const splitValue = String(value).split(', ')
      if (splitValue.length > 0 && splitValue.find(el => el !== 'undefined')) {
        let newValue = splitValue.map(el => {
          if (!LOG_VALUE_SETTINGS[el]) {
            if (this.isValidGuid(el) && FILE_CATEGORY[field]) {
              const file = this.files[FILE_CATEGORY[field]] &&
              this.files[FILE_CATEGORY[field]].find(i => i.guid === el)
              return file ? file.file_name : el
            }
            return el
          }
          return LOG_VALUE_SETTINGS[el].label
        }).join(', ')

        return { label: newValue }
      }
      return { label: value }
    }
  }
}
</script>

<style>

</style>
